export default __webpack_public_path__ + "static/media/cross.cf2986ad.svg";